/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { FilterStore } from '../stores';

export const FilterContext = createContext<FilterStore>({} as FilterStore);
